import _ from 'lodash'
import React from 'react'
// import classes from './styles.module.scss'
// import { FormattedMessage } from 'react-intl'
// import messages from './messages'
// import { Button } from 'antd'
import ApplePay from '../ApplePay'
import GooglePay from '../GooglePay'
import SamsungPay from '../SamsungPay'
export default class DevicePay extends React.Component {
  // constructor (props) {
  //   super(props)
  //   this.state = {
  //     foo: 'foo'
  //   }
  // }

  submit = (data) => {
    const { item = {}, submit } = this.props
    submit({ ...data, tabName: item.tabName })
  }

  render() {
    const { item = {}, siteConfig, actions, orderLabel } = this.props
    switch (_.get(item, 'payMethod.payMethodExtension.payChannel')) {
      case '35':
        console.log('item', 'DevicePay')
        return (
          <ApplePay
            {...item}
            {...siteConfig}
            orderLabel={orderLabel}
            validateURL={actions.applePayValidateURL}
            submit={this.submit}
          />
        )
      case '36':
        return <GooglePay {...item} {...siteConfig} submit={this.submit} />
      case '37':
        return (
          <SamsungPay
            orderNumber={siteConfig?.orderNo}
            total={siteConfig?.payInfo?.payAmount?.amount}
            merchantName={siteConfig?.merchantName}
            {...item}
            {...siteConfig}
            submit={this.submit}
          />
        )
      default:
        return null
    }
  }
}
